export class DashboardIframeData {
	Title:string = "";
	ShowTitle:boolean = true;
	Url:string = "";
	NoBorder:boolean = false;
	UseDesktopAppAsProxy:boolean = false;
	WidthMode:"flex"|"fixed" = "flex";
	FixedWidth:number = 300;


	public constructor(data?:any){
		if (!data)return;
		this.Url = data.Url;
		this.ShowTitle = data.ShowTitle == "true";
		this.Title = data.Title;
		this.NoBorder = data.NoBorder == "true";
		this.UseDesktopAppAsProxy = data.UseDesktopAppAsProxy == "true";
		this.WidthMode = data.WidthMode || "flex";
		this.FixedWidth = parseInt(data.FixedWidth || "300");
	}

	public getJSON(){
		return {
			Url: this.Url.trim(),
			ShowTitle: `${this.ShowTitle || false}`,
			Title: this.Title.trim(),
			NoBorder: `${this.NoBorder || false}`,
			UseDesktopAppAsProxy: `${this.UseDesktopAppAsProxy || false}`,
			WidthMode: this.WidthMode,
			FixedWidth: `${this.FixedWidth}`
		};
	}
}